import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface Site {
  id: string;
  name: string;
  code: string;
  timezone?: string;
}

interface SiteState {
  selectedSite: Site | null;
  availableSites: Site[];
}

const initialState: SiteState = {
  selectedSite: null,
  availableSites: [],
};

const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {
    setSelectedSite: (state, action: PayloadAction<Site | null>) => {
      state.selectedSite = action.payload;
    },
    setAvailableSites: (state, action: PayloadAction<Site[]>) => {
      state.availableSites = action.payload;
    },
    clearSiteSelection: (state) => {
      state.selectedSite = null;
    },
  },
});

export const { setSelectedSite, setAvailableSites, clearSiteSelection } = siteSlice.actions;
export default siteSlice.reducer;